/**
 * Shared utilities for company form components
 */

/**
 * Map check layout type string to numeric ID
 * Used when saving company data to API
 */
export const CHECK_LAYOUT_TYPE_TO_ID_MAP: Record<string, number> = {
  standard: 1,
  detailed: 2,
  'tip-credit': 3,
  FAR: 4,
};

/**
 * Map check layout ID to type string
 * Used when loading company data from API
 */
export const CHECK_LAYOUT_ID_TO_TYPE_MAP: Record<number, string> = {
  1: 'standard',
  2: 'detailed',
  3: 'tip-credit',
  4: 'FAR',
};
